import { request } from 'util/request';

async function fetchDriversLocations(params?: any) {
  return request('driver/locations', params, 'GET');
}

export { fetchDriversLocations }
